import { createContext, useContext, useEffect, ReactNode } from 'react'
import useHasFocus from 'hooks/useHasFocus'
import { isTokenExpired } from 'utils/isTokenExpired'
import { getTokenFromCookies, resetTokenFromCookies } from 'utils/tokenFromCookies'
import { HandlerErrorMessage } from 'utils/HandlerErrorMessage'
import { useSnackbarAlertContext } from './SnackbarContext'

type AuthContextType = {
  focus: boolean
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

type AuthProviderProps = {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const focus = useHasFocus()
  const token = getTokenFromCookies()
  const { showAlert } = useSnackbarAlertContext()

  useEffect(() => {
    if (focus) {
      checkToken()
    }
  }, [focus])

  const checkToken = () => {
    if (token && isTokenExpired(token)) {
      resetTokenFromCookies()
      HandlerErrorMessage({
        customErrorMessage: 'Sessão expirada, faça login novamente',
        showAlert
      })
      window.location.href = '/'
    }
  }

  return <AuthContext.Provider value={{ focus }}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider')
  }
  return context
}
